// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "ClientNeedFiltersAreasAutocomplete_schoolDistricts", undefined);
}

function getConnectionNodes(connection) {
  if (connection === undefined) {
    return [];
  }
  let edges = connection.edges;
  if (edges !== undefined) {
    return Stdlib_Array.filterMap(edges, edge => {
      if (edge !== undefined) {
        return edge.node;
      }
    });
  } else {
    return [];
  }
}

let Utils = {
  getConnectionNodes: getConnectionNodes
};

let node = {
  "kind": "InlineDataFragment",
  "name": "ClientNeedFiltersAreasAutocomplete_clientNeedFilters_schoolDistricts"
};

exports.Types = Types;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
